import axiosServices from '../utils/axios';
const backendUrl = import.meta.env.VITE_BACKEND_URL;

export const fetchNotifications = async (offset = 0, limit = 6, status = '') => {
  const response = await axiosServices.get(`${backendUrl}/notifications`, {
    params: { offset, limit, notification_status: status, include_total: true },
  });
  return response.data;
};
export const markAsReadNotification = async (id) => {
  const response = await axiosServices.post(`${backendUrl}/notifications/${id}`, {
    status: 'read',
    read_time: new Date().toISOString(),
  });
  return response.data;
};

export const markAllAsReadNotification = async () => {
  const response = await axiosServices.put(`${backendUrl}/notifications/mark-all-as-read`, {
    read_time: new Date().toISOString(),
  });
  return response.data;
};
